import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { playerAttributesPayloadSchema } from './player';

export type UpdatePlayerPayload = z.output<typeof updatePlayerPayloadSchema>;
export type UpdatePlayerPayloadDTO = z.input<typeof updatePlayerPayloadSchema>;

export const updatePlayerPayloadSchema = z.object({
  attributes: playerAttributesPayloadSchema.optional(),
  attributesDate: isoDatetimeToDate.optional(),
  firstName: z.string().min(1).optional(),
  lastName: z.string().min(1).optional(),
});
